export const enum ORG_ADD_MODE {
    ADD_ENTERPRICE = 'ADD_ENTERPRICE',
    ADD = 'ADD',
    EDIT_ENTERPRICE = 'EDIT_ENTERPRICE',
    EDIT = 'EDIT',
}

export const enum TemplateShareMode {
    READ = '1',
    USE = '3',
    WRITE = '5',
    WRITE_USE = '7',
    NA = '0',
}
export const OrgAsTemplateIdInShareSelection =
    '00000000-0000-0000-0000-000000000000'

export const enum OrgShareStatus {
    ACTIVE = 'ACTIVE',
    DELETE = 'DELETED',
    NA = 'NA',
}

export const ROOT_ORG = 'root'
